import { useEffect, useRef } from "react";
import { useBlocker, useLocation } from "react-router-dom";

export function useNavigationPrompt(
  when: boolean,
  message: string,
  handleSave: () => Promise<void>,
  handleUnlock: () => Promise<void>,
) {
  const blocker = useBlocker(() => when);
  const currentLocation = useLocation();
  const isProcessingRef = useRef(false);

  useEffect(() => {
    if (when && blocker.state === "blocked" && !isProcessingRef.current) {
      const nextPath = blocker.location.pathname;

      // 現在のパスと次のパスが同じ場合、リセットして続行
      if (currentLocation.pathname === nextPath) {
        blocker.proceed();
        return;
      }

      isProcessingRef.current = true;
      const confirmExit = window.confirm(message);
      if (confirmExit) {
        // 変更を保存してからロックを解除し、ナビゲーションを続行
        handleSave()
          .then(() => handleUnlock())
          .then(() => {
            // blocker stateが'blocked'の場合のみproceedを呼ぶ
            if (blocker.state === "blocked") {
              blocker.proceed();
            }
          })
          .catch((error) => {
            console.error("Failed to save or unlock:", error);
            // blocker stateが'blocked'の場合のみresetを呼ぶ
            if (blocker.state === "blocked") {
              blocker.reset();
            }
          })
          .finally(() => {
            isProcessingRef.current = false;
          });
      } else {
        // キャンセルの場合はナビゲーションをブロックし、編集状態を維持
        if (blocker.state === "blocked") {
          blocker.reset();
        }
        isProcessingRef.current = false;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [when, blocker, handleSave, handleUnlock, message, currentLocation.pathname]);
}
